import type { ReactNode } from 'react'
import emptyIllustration from '@/assets/empty-catalog.png'

interface Props {
  title: string
  description?: string
  action?: ReactNode
}

export const EmptyState = ({ title, description, action }: Props) => (
  <div className="flex flex-col items-center justify-center py-16 px-4 text-center">
    <img src={emptyIllustration} alt="" className="w-48 h-48 object-contain opacity-80 mb-6" />
    <h3 className="text-xl font-semibold text-foreground mb-2">{title}</h3>
    {description ? (
      <p className="text-sm text-muted-foreground max-w-sm mb-6">{description}</p>
    ) : null}
    {action}
  </div>
)
